import React from "react"
import { getExecutionsSidebarColor } from "../../../../utils/productionStepExecution"

const CookingIcon = ({ isSelected = false }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path
                d="M11.6 5.9L15 0L16.7 1L13.9 5.9H11.6ZM13.3 6.9H18V8.9H16V15.9C16 17 15.1 17.9 14 17.9H4C2.9 17.9 2 17 2 15.9V8.9H0V6.9H13.3ZM14 8.9H4V15.9H14V8.9Z"
                fill={getExecutionsSidebarColor(isSelected)}
            />
        </svg>
    )
}

export default CookingIcon